module.exports = __webpack_public_path__ + "static/media/p8.098483b4.csv";